// router views
import { orderBy, cloneDeep } from 'lodash'

// import Home from '@/components/Home'
import Home from '@/components/Home'
import InteractiveMap from '@/components/InteractiveMap'
import Login from '@/components/Login'
import Page404 from '@/components/Page404'
import PathNotActive from '@/components/PathNotActive'
import Logout from '@/components/Logout'
import WorkInProgress from '@/components/WorkInProgress'
import RefreshPage from '@/components/RefreshPage'

// organization
import User from '@/components/organization/User'
import EditUser from '@/components/organization/EditUser'
import Vehicle from '@/components/organization/Vehicle'
import EditVehicle from '@/components/organization/EditVehicle'
import Insurance from '@/components/organization/Insurance'
import Operation from '@/components/organization/Operation'
import EditOperation from '@/components/organization/EditOperation'
import managementObu from '@/components/organization/managementObu'
import Staff from '@/components/organization/Staff'
import EditStaff from '@/components/organization/EditStaff'
import Accident from '@/components/organization/Accident'
import EditAccident from '@/components/organization/EditAccident'
import Recipients from '@/components/organization/Recipients'
import EditRecipients from '@/components/organization/EditRecipients'
import Scheduling from '@/components/organization/Scheduling'
import EditPenaltyChargeNotice from '@/components/penalty_charge_notice/EditPenaltyChargeNotice'
import PenaltyChargeNotice from '@/components/penalty_charge_notice/PenaltyChargeNotice'
import MotivationsRegistry from '@/components/penalty_charge_notice/MotivationsRegistry'
// report
import ReportVehicles from '@/components/report/ReportVehicles'
import ReportKmVehiclesHired from '@/components/report/ReportKmVehiclesHired'
import ReportStop from '@/components/report/ReportStops'
import VehicleServices from '@/components/report/VehicleServices'
import Logs from '@/components/report/Logs'
import RepoInsurance from '@/components/report/RepoInsurance'

// configuration
import ConfigurationsEnums from '@/components/configuration/ConfigurationsEnums'

import penaltyIcon from '@/assets/penalty.svg'
import AWDocAuthentication from '@/components/AWDocAuthentication'
import Asset from '@/components/organization/Asset.vue'
import EditAsset from '@/components/organization/EditAsset'
import USE_ASSET from '../src/plugins/my-server-interaction.js'
const allItems = [
  {
    header: true,
    title: [
      { option: 'message.navigate' }
    ],
    hiddenOnCollapse: true,
    meta: {
      hideInConfig: true
    }
  },
  {
    title: [
      { option: 'message.home' }
    ],
    icon: 'fa fa-home',
    path: '/home',
    component: Home,
    componentName: 'Home',
    meta: {
      config: { r: true },
      functions: [
        { url: '/drivers', i18nItem: 'staff' },
        { url: '/trackers', i18nItem: 'obu' },
        { url: '/vehicles', i18nItem: 'vehicle' },
      ]
    }
  },
  {
    title: [
      { option: 'message.interactiveMap' }
    ],
    path: '/map',
    icon: 'fa fa-map-marked-alt',
    component: InteractiveMap,
    componentName: 'InteractiveMap',
    meta: {
      config: { r: true },
      functions: [
        { url: '/drivers', i18nItem: 'staff' },
        { url: '/trackers', i18nItem: 'obu' },
        { url: '/vehicles', i18nItem: 'vehicle' }
      ]
    }
  },
  {
    title: [
      { option: 'message.login', num: 1 }
    ],
    path: '/',
    component: Login,
    componentName: 'Login',
    meta: {
      hideInConfig: true,
      functions: [
        { url: '/login', i18nItem: 'log' }
      ]
    }
  },
  {
    title: 'Accesso AWDoc',
    path: '/awdoc',
    icon: 'fa fa-folder-open',
    component: AWDocAuthentication,
    componentName: 'AWDocAuthentication',
    meta: {
      hideInConfig: false
    }
  },
  {
    title: [
      { option: 'message.organization', num: 1 }
    ],
    icon: 'fa fa-users',
    componentName: 'Organizzazione',
    meta: {
      config: { c: true, r: true, u: true, d: true }
    },
    child: [
      {
        title: [
          { option: 'message.attachment', num: 2 }
        ],
        path: '/attachment',
        component: WorkInProgress,
        componentName: 'attachment',
        meta: {
          hideRoute: true,
          hideInConfig: true
        }
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.staff', num: 1 }
        ],
        path: '/organization/registry_staff',
        component: Staff,
        componentName: 'Staff',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.registry', num: 1 },
              { option: 'message.staff', num: 1 }
            ],
            path: '/organization/registry_staff/:id',
            component: EditStaff,
            componentName: 'EditStaff',
            meta: {
              config: { c: true, r: true, u: true, d: true }
            }
          }
        ]
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.vehicle', num: 2 }
        ],
        path: '/organization/registry_vehicles',
        component: Vehicle,
        componentName: 'Vehicle',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.vehicle', num: 2 }
            ],
            path: '/organization/registry_vehicles/:id',
            component: EditVehicle,
            componentName: 'EditVehicle',
            meta: {
              config: { c: true, r: true, u: true, d: true },
              sections: [
                'identityData',
                'extraData',
                'vehicleUsage',
                'albo2',
                'equipment',
                'service',
                'insurance',
                'attachment',
                'obu'
              ]
            }
          }
        ]
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.user', num: 2 }
        ],
        path: '/organization/registry_user',
        component: User,
        componentName: 'User',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.user', num: 2 }
            ],
            path: '/organization/registry_user/:id',
            component: EditUser,
            componentName: 'EditUser',
            meta: {
              config: { c: true, r: true, u: true, d: true }
            }
          }
        ]
      },
      {
        title: [
          { option: 'message.recipients', num: 2 }
        ],
        path: '/recipients',
        component: Recipients,
        componentName: 'Recipients',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.recipients', num: 2 }
            ],
            path: '/recipients/:id',
            component: EditRecipients,
            componentName: 'EditRecipients',
            meta: {
              config: { c: true, r: true, u: true, d: true }
            }
          }
        ]
      },
      {
        title: [
          { option: 'message.management' },
          { option: 'message.operation', num: 2 }
        ],
        path: '/organization/operation',
        component: Operation,
        componentName: 'Operation',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.operation', num: 2 }
            ],
            path: '/organization/operation/:id',
            component: EditOperation,
            componentName: 'EditOperation',
            meta: {
              config: { c: true, r: true, u: true, d: true }
            }
          }
        ]
      },
      {
        title: [
          { option: 'message.management' },
          { option: 'message.obu', disableLowerCase: true }
        ],
        path: '/obu_management',
        component: managementObu,
        componentName: 'managementObu',
        meta: {
          config: { r: true, c: true }
        }
      },
      {
        title: [
          { option: 'message.insurance', num: 2 }
        ],
        path: '/insurance',
        component: Insurance,
        componentName: 'Insurance',
        meta: {
          config: { r: true }
        }
      },
      {
        title: [
          { option: 'message.accident', num: 2 }
        ],
        path: '/organization/accident',
        component: Accident,
        componentName: 'Accident',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.accident', num: 2 }
            ],
            path: '/organization/accident/:id',
            component: EditAccident,
            componentName: 'EditAccident',
            meta: {
              config: { c: true, r: true, u: true, d: true }
            }
          }
        ]
      },
      USE_ASSET ? {
        title: [
          { option: 'message.asset', num: 2 }
        ],
        path: '/organization/asset',
        component: Asset,
        componentName: 'Asset',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        },
        child: [
          {
            title: [
              { option: 'message.edit' },
              { option: 'message.asset', num: 2 }
            ],
            path: '/organization/asset/:id',
            component: EditAsset,
            componentName: 'EditAsset',
            meta: {
              config: { c: true, r: true, u: true, d: true }
            }
          }
        ]
      } : {},
      {
        title: [
          { option: 'message.management', num: 1 },
          { option: 'message.notification', num: 2 }
        ],
        path: '/organization/scheduling',
        component: Scheduling,
        componentName: 'Scheduling',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        }
      }
    ]
  },
  {
    title: [
      { option: 'message.configuration', num: 1 }
    ],
    icon: 'fa fa-cogs',
    meta: {
      config: { c: true, r: true, u: true, d: true }
    },
    child: [
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.property', num: 1 }
        ],
        path: '/configuration/owner',
        component: ConfigurationsEnums,
        componentName: 'owner',
        meta: {
          enumSwitcher: 'owner',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.userType', num: 1 }
        ],
        path: '/configuration/user_type',
        component: ConfigurationsEnums,
        componentName: 'user_type',
        meta: {
          enumSwitcher: 'user_type',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.sector', num: 1 },
          { option: 'message.activity', num: 1 }
        ],
        path: '/configuration/activity_sector',
        component: ConfigurationsEnums,
        componentName: 'activity_sector',
        meta: {
          enumSwitcher: 'activity_sector',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.society', num: 1 }
        ],
        path: '/configuration/company',
        component: ConfigurationsEnums,
        componentName: 'company',
        meta: {
          enumSwitcher: 'company',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.status', num: 1 },
          { option: 'message.vehicle', num: 1 }
        ],
        path: '/configuration/vehicle_state',
        component: ConfigurationsEnums,
        componentName: 'vehicle_state',
        meta: {
          enumSwitcher: 'vehicle_state',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.code', num: 2 },
          { option: 'message.albo2' }
        ],
        path: '/configuration/registry_code',
        component: ConfigurationsEnums,
        componentName: 'registry_code',
        meta: {
          enumSwitcher: 'registry_code',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.causal' },
          { option: 'message.operation', num: 2 }
        ],
        path: '/configuration/operation',
        component: ConfigurationsEnums,
        componentName: 'operation',
        meta: {
          enumSwitcher: 'operation',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.insuranceCompany', num: 1 }
        ],
        path: '/configuration/insurance_company',
        component: ConfigurationsEnums,
        componentName: 'insurance_company',
        meta: {
          enumSwitcher: 'insurance_company',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.status', num: 1 },
          { option: 'message.accident', num: 1 }
        ],
        path: '/configuration/accident_state',
        component: ConfigurationsEnums,
        componentName: 'accident_state',
        meta: {
          enumSwitcher: 'accident_state',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.vehicleSetUp', num: 1 }
        ],
        path: '/configuration/equipment',
        component: ConfigurationsEnums,
        componentName: 'equipment',
        meta: {
          enumSwitcher: 'equipment',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.document', num: 1 }
        ],
        path: '/configuration/document_type',
        component: ConfigurationsEnums,
        componentName: 'document_type',
        meta: {
          enumSwitcher: 'document_type',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.drivingLicense', num: 1 }
        ],
        path: '/configuration/driving_license',
        component: ConfigurationsEnums,
        componentName: 'driving_license',
        meta: {
          enumSwitcher: 'driving_license',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.refueling', num: 1 }
        ],
        path: '/configuration/fuel_type',
        component: ConfigurationsEnums,
        componentName: 'fuel_type',
        meta: {
          enumSwitcher: 'fuel_type',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.service', num: 1 }
        ],
        path: '/configuration/service_type',
        component: ConfigurationsEnums,
        componentName: 'service_type',
        meta: {
          enumSwitcher: 'service_type',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.vehicle', num: 1 }
        ],
        path: '/configuration/classification',
        component: ConfigurationsEnums,
        componentName: 'classification',
        meta: {
          enumSwitcher: 'classification',
          config: { c: true, r: true, u: true, d: true }
        }
      },
      USE_ASSET ? {
        title: [
          { option: 'message.type', num: 1 },
          { option: 'message.asset', num: 1 }
        ],
        path: '/configuration/asset_type',
        component: ConfigurationsEnums,
        componentName: 'asset_type',
        meta: {
          enumSwitcher: 'asset_type',
          config: { c: true, r: true, u: true, d: true }
        }
      } : {}
    ]
  },
  {
    title: [
      { option: 'message.report' }
    ],
    icon: 'fas fa-clipboard-list',
    meta: {
      config: { r: true }
    },
    child: [
      {
        title: [
          { option: 'message.vehicle', num: 2 }
        ],
        path: '/report/vehicles',
        component: ReportVehicles,
        componentName: 'ReportVehicles',
        meta: {
          config: { r: true }
        }
      },
      {
        title: [
          { option: 'message.km', num: 1 },
          { option: 'message.vehicle', num: 2 },
          { option: 'message.hired', num: 2 }
        ],
        path: '/report/km-vehicles-hired',
        component: ReportKmVehiclesHired,
        componentName: 'ReportKmVehiclesHired',
        meta: {
          config: { r: true }
        }
      },
      {
        title: [
          { option: 'message.travel', num: 1 }
        ],
        path: '/report/travel',
        component: ReportStop,
        componentName: 'ReportStop',
        meta: {
          config: { r: true },
          functions: [
            { url: '/vehicles', i18nItem: 'vehicle' }
          ]
        }
      },
      {
        title: [
          {
            option: 'message.service',
            num: 2
          }
        ],
        path: '/report/services',
        component: VehicleServices,
        componentName: 'VehicleServices',
        meta: {
          config: { r: true }
        }
      },
      {
        title: [
          { option: 'message.log', num: 2 }
        ],
        path: '/report/logs',
        component: Logs,
        componentName: 'Logs',
        meta: {
          config: { r: true }
        }
      },
      {
        title: [
          { option: 'message.expiration', num: 1 },
          { option: 'message.insurance', num: 1 }
        ],
        path: '/report/insurance',
        component: RepoInsurance,
        componentName: 'RepoInsurance',
        meta: {
          config: { r: true }
        }
      }
    ]
  },
  {
    title: [
      { option: 'message.penaltyChargeNoticeManagement' }
    ],
    icon: {
      element: 'img',
      class: 'penalty-icon',
      attributes: { src: penaltyIcon }
    },
    meta: {
      config: { c: true, r: true, u: true, d: true }
    },
    child: [
      {
        title: [
          { option: 'message.violation', num: 3 }
        ],
        path: '/penalty_charge_notice',
        component: PenaltyChargeNotice,
        componentName: 'PenaltyChargeNotice',
        meta: {
          config: { c: true, r: true, u: true, d: true },
          sections: [
            'violationData',
            'attachment',
            'verification',
            'payment',
            'employeeNotification',
            'dispute'
          ]
        }
      },
      {
        title: [
          { option: 'message.edit' },
          { option: 'message.penaltyChargeNotice' }
        ],
        path: '/penalty_charge_notice/:id',
        component: EditPenaltyChargeNotice,
        componentName: 'EditPenaltyChargeNotice',
        meta: {
          config: { c: true, r: true, u: true, d: true },
          sections: [
            'violationData',
            'attachment',
            'verification',
            'payment',
            'employeeNotification',
            'dispute'
          ]
        }
      },
      {
        title: [
          { option: 'message.registry', num: 1 },
          { option: 'message.motivation', num: 2 }
        ],
        path: '/motivations_registry',
        component: MotivationsRegistry,
        componentName: 'MotivationsRegistry',
        meta: {
          config: { c: true, r: true, u: true, d: true }
        }
      }
    ]
  },

  {
    title: [
      { option: 'message.logout', num: 1 }
    ],
    icon: 'fas fa-sign-out-alt',
    path: '/logout',
    component: Logout,
    componentName: 'Logout',
    meta: {
      hideInConfig: true
    }
  }
]

const routes = []

allItems.forEach((group) => {
  if (!group.meta || (group.meta && !group.meta.hideRoute)) {
    getRoutes(group)
  }
})

routes.push({ path: '/path_not_active', name: 'PathNotActive', component: PathNotActive })
routes.push({ path: '/redirect', name: 'RefreshPage', component: RefreshPage })
routes.push({ path: '*', name: 'Page404', component: Page404 })

function getTitle (it, child) {
  let name = ''
  if (child && child.title) {
    if (child.title && Array.isArray(child.title)) {
      child.title.forEach((nameChunk, index) => {
        if (it._i18n) {
          if (typeof nameChunk.num === 'number' && index === 0) {
            name += `${it.$tc(nameChunk.option, nameChunk.num)} `
          } else if (typeof nameChunk.num === 'number' && index !== 0) {
            name += `${it.$tc(nameChunk.option, nameChunk.num).toLowerCase()} `
          } else if (isNaN(nameChunk.num) && index !== 0 && !nameChunk.disableLowerCase) {
            name += `${it.$t(nameChunk.option).toLowerCase()} `
          } else {
            name += `${it.$t(nameChunk.option)} `
          }
        }
      })
    } else {
      name = child.title
    }
  }
  return name
}

function getRoutes (collection) {
  if (collection.path && collection.componentName && collection.component) {
    if (!collection.meta || (collection.meta && !collection.meta.hideRoute)) {
      routes.push({
        path: collection.path,
        name: collection.componentName,
        component: collection.component,
        meta: collection.meta ? collection.meta : {}
      })
    }
  }
  if (collection.child) {
    collection.child.forEach((child) => {
      getRoutes(child)
    })
  }
}

function getSidebarItems (it, collection) {
  const editedCollection = {
    title: getTitle(it, collection)
  }
  if (collection && collection.icon) {
    editedCollection.icon = collection.icon
  }
  if (collection && collection.path) {
    editedCollection.href = collection.path
  }
  if (collection && collection.header) {
    editedCollection.header = collection.header
    editedCollection.hiddenOnCollapse = collection.hiddenOnCollapse
  }
  if (collection && collection.componentName) {
    editedCollection.componentName = collection.componentName
  }

  const children = []
  if (collection && collection.child) {
    collection.child.forEach((child) => {
      if (!child.meta || (child.meta && !child.meta.hideRoute)) {
        const foundedChild = getSidebarItems(it, child)
        if (foundedChild) {
          children.push(foundedChild)
        }
      }
    })
  }
  if (children.length !== 0) {
    editedCollection.child = orderBy(children, 'title')
  }

  let isDynamicRoute = false
  if (collection && collection.path) {
    const pathSections = collection.path.split('/')
    pathSections.forEach((pathSection) => {
      if (pathSection === ':id') {
        isDynamicRoute = true
      }
    })
  }

  if (!isDynamicRoute && collection && collection.path !== '/') {
    return editedCollection.title ? editedCollection : null
  }
  return null
}

function getFooterButtons (it, allItems, config) {
  const buttons = []
  if (allItems && allItems.length > 0) {
    allItems.forEach((item) => {
      if (item.title && item.path && item.path !== '/') {
        if (!item.meta || (item.meta && !item.meta.hideRoute)) {
          let foundedItem = null
          if (config && config.length > 0) {
            config.forEach(confItem => {
              if (item.path === confItem.path) foundedItem = confItem
            })
          }

          // config[crud], create - read - update - delete
          if ((foundedItem && foundedItem.meta && foundedItem.meta.config && foundedItem.meta.config.r) || !foundedItem) {
            buttons.push({ title: item.title, href: `${item.path}` })
          }
        }
      }
    })
  }
  return buttons
}

function getConfigItems (it, collection) {
  const editedCollection = {
    title: getTitle(it, collection),
    path: collection.path,
    componentName: collection.componentName,
    config: (collection.meta && collection.meta.config) || { c: false, r: true, u: false, d: false }
  }

  const children = []
  if (collection && collection.child) {
    collection.child.forEach((child) => {
      if (!child.meta || ((child.meta && !child.meta.hideRoute && !child.meta.hideInConfig))) {
        const foundedChild = getConfigItems(it, child)
        if (child.meta) foundedChild.meta = child.meta
        if (foundedChild) {
          children.push(foundedChild)
        }
      }
    })
  }
  editedCollection.child = orderBy(children, 'title')

  if (collection && collection.path !== '/') return editedCollection.title ? editedCollection : null
  return null
}

function findRoute (result, routes) {
  let foundedItem = null

  if (!routes || routes.length === 0) return null

  routes.forEach(route => {
    if (result.componentName === route.componentName || result.href === route.path) {
      // config[crud], create - read - update - delete
      if (!foundedItem && route.config && route.config.r) {
        foundedItem = result
      }
    } else if (route.child) {
      // config[crud], create - read - update - delete
      if (!foundedItem && route.config && route.config.r) foundedItem = findRoute(result, route.child)
    }
  })
  return foundedItem
}

function myFilter (results, routes) {
  const editedItems = []

  results.forEach(result => {
    const foundedItem = findRoute(result, routes)
    const editedItem = cloneDeep(result)

    if (foundedItem || result.header || result.href === '/logout' || result.href === '/home') {
      if (result.child) {
        const children = myFilter(result.child, routes)
        if (children.length !== 0) {
          editedItem.child = children
          editedItems.push(editedItem)
        }
      } else {
        editedItems.push(editedItem)
      }
    }
  })

  return editedItems
}

export default {
  allItems,
  routes,
  footerButtons: (it, config) => getFooterButtons(it, allItems, config),
  sidebarItems: (it, routes) => {
    const results = []
    allItems.forEach((collection) => {
      if (!collection.meta || (collection.meta && !collection.meta.hideRoute)) {
        const result = getSidebarItems(it, collection)
        if (result) {
          results.push(result)
        }
      }
    })
    return routes ? myFilter(results, routes) : results
  },
  configItems: (it) => {
    const results = []
    allItems.forEach((collection) => {
      if (!collection.meta || ((collection.meta && !collection.meta.hideRoute && !collection.meta.hideInConfig))) {
        const result = getConfigItems(it, collection)
        if (result && result.path !== '/home') {
          results.push(result)
        }
      }
    })
    return results
  }
}
